export enum ChainKey {
  // EVM
  ETH = 'eth',
  POL = 'pol',
  BSC = 'bsc',
  DAI = 'dai',
  FTM = 'ftm',
  AVA = 'ava',
  ARB = 'arb',
  HEC = 'hec',
  OPT = 'opt',
  ONE = 'one',
  FSN = 'fsn',
  MOR = 'mor',
  EXP = 'exp',
  TCH = 'tch',
  UBQ = 'ubq',
  MET = 'met',
  DIO = 'dio',
  CEL = 'cel',
  FUS = 'fus',
  TLO = 'tlo',
  CRO = 'cro',
  BOB = 'bob',
  SHI = 'shi',
  GL1 = 'gl1',
  RSK = 'rsk',
  TBW = 'tbw',
  VEL = 'vel',
  MOO = 'moo',
  MAM = 'mam',
  AUR = 'aur',
  EVM = 'evm',
  ARN = 'arn',
  ERA = 'era',
  PZE = 'pze',
  LNA = 'lna',
  BAS = 'bas',
  SCL = 'scl',
  MOD = 'mod',
  MNT = 'mnt',
  BLS = 'bls',
  SEI = 'sei',
  FRA = 'fra',

  // None-EVM
  SOL = 'sol',
  TER = 'ter',
  OAS = 'oas',

  // UXTO
  BTC = 'btc',
  BCH = 'bch',
  LTC = 'ltc',
  DGE = 'dge',
}

export enum ChainId {
  ETH = 1,
  POL = 137,
  BSC = 56,
  DAI = 100,
  FTM = 250,
  AVA = 43114,
  ARB = 42161,
  HEC = 128,
  OPT = 10,
  ONE = 1666600000,
  FSN = 32659,
  MOR = 1285,
  EXP = 2,
  TCH = 7,
  UBQ = 8,
  MET = 11,
  DIO = 15,
  CEL = 42220,
  FUS = 122,
  TLO = 40,
  CRO = 25,
  BOB = 288,
  SHI = 27,
  GL1 = 29,
  RSK = 30,
  TBW = 35,
  VEL = 106,
  MOO = 1284,
  MAM = 1088,
  AUR = 1313161554,
  EVM = 9001,
  ARN = 42170,
  ERA = 324,
  PZE = 1101,
  LNA = 59144,
  BAS = 8453,
  SCL = 534352,
  MOD = 34443,
  MNT = 5000,
  BLS = 81457,
  SEI = 1329,
  FRA = 252,

  // None-EVM (IDs are made up by the LI.FI team)
  SOL = 1151111081099710,
  TER = 1161011141099710,
  OAS = 111971151099710,

  // UXTO (IDs are made up by the LI.FI team)
  BTC = 20000000000001,
  BCH = 20000000000002,
  LTC = 20000000000003,
  DGE = 20000000000004,
}
